<template>
  <div
    class="bg-F5F5F5 relative scroll-y h-fullVh"
    ref="pageSubstituteIndex"
    @scroll="handlerScroll"
  >
    <div :style="{ height: `${scrollHeight}px` }" class="bt">
      <!-- 头部提示文字 -->
      <div
        class="h-56 fb-between-center p-0-15 font-32 relative"
        v-if="isCanChangeRole"
      >
        <div class="change-role c-006AFE" @click="handlerToChangeRole">
          <span class="mr-8">家长</span>
          <i class="iconfont font-28 c-006AFE">&#xe613;</i>
        </div>
        <div
          class="customer-service"
          v-if="computedShowCustomerService"
          @click="openCsLink"
        >
          <span class="iconfont mr-2 text-bold-600">&#xe731;</span>
          <span>客服</span>
        </div>
        <md-tip v-model="visible" type="primary" direction="top" class="cs-tip"
          >点击这里咨询客服</md-tip
        >
      </div>
      <div class="guardian ff-regular">
        <div class="guardian-wrapper">
          <div class="guardian-header">
            <div
              class="guardian-header__avatar"
              v-if="student && student.avatarImage"
              :style="{ backgroundImage: `url(${student.avatarImage})` }"
            ></div>
            <div class="c-171A1D">
              <div
                class="font-34 mr-4 mb-8 fb fb-main-start fb-cross-center ff-medium"
                @click="switchChild"
              >
                <span class="inline-block max-w-100 text-ellipsis">{{
                  nameFormat(student.name, 5)
                }}</span>
                <i
                  class="iconfont font-26 ml-4 switch-icon"
                  v-if="this.$store.getters.studentList.length > 1"
                  >&#xe6ba;</i
                >
              </div>
              <div class="font-24 fb fb-main-start">
                <div class="fb fb-main-start fb-cross-center">
                  <img src="@/assets/images/guardian/icon-classname.png" />
                  <span class="inline-block">
                    {{
                      nameFormat(student.className || student.classNickName, 9)
                    }}</span
                  >
                </div>
                <div
                  class="ml-16 fb fb-main-start fb-cross-center"
                  v-if="student.adviserName"
                >
                  <img src="@/assets/images/guardian/icon-headmaster.png" />
                  <span class="inline-block max-w-100 text-ellipsis">{{
                    nameFormat(student.adviserName, 5)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 模块列表 -->
          <div class="guardian-module-wrapper">
            <ul class="guardian-module c-191F25">
              <!--  德育考评、给孩子留言、光盘行动、每日食谱、班级课表、选修课 自定义校区不需要显示 -->
              <li
                v-for="(item, index) in iconList"
                :key="index"
                @click="goPage(item)"
              >
                <img
                  v-if="item.icon"
                  :src="
                    require(`../assets/images/guardian/icon-${item.icon}.png`)
                  "
                />
                <p class="font-22">{{ item.text }}</p>
              </li>
            </ul>
          </div>
          <div v-if="cpIsHaveAblum" @click="goAblum">
            <img
              class="mt-16"
              src="@/assets/images/guardian/album260306_3.png"
              alt="电子相册"
            />
          </div>
          <!-- 待办 & 通知 -->
          <div
            class="guardian-notice c-171A1D font-34 lh-24"
            v-for="(notice, index) in cpNotifyList"
            :key="notice.id"
            :class="{
              'mb-8': index < cpNotifyList.length - 1,
              'mt-12': index === 0
            }"
            @click="handlerClickNotice(notice)"
          >
            <div class="font-30">
              <span class="font-22 c-4250C3" style="margin-top: -3px">{{
                notice.type === 1 ? '通知' : '待办'
              }}</span>
              {{ notice.content }}
            </div>
            <i class="iconfont">&#xe68d;</i>
          </div>
          <!-- 卡片流 -->
          <div class="guardian-card c-171A1D mt-12">
            <div v-if="!hasFace">
              <div class="guardian-card__date font-26 mt-12"> 系统置顶 </div>
              <div class="font-30 p-16 bg-FFFFFF bd-radio-8">
                <title-icon class="mb-15" title="信息录入" />
                <face :name="student.name" />
              </div>
            </div>
            <div v-for="(item, index) in dateGather" :key="index">
              <div class="guardian-card__date font-26 mt-24">{{
                formatTime[item]
              }}</div>
              <div
                class="guardian__leave font-30"
                v-if="
                  leaveStartDate <= item && leaveEndDate >= item && todayLeave
                "
              >
                <img
                  src="@/assets/images/guardian/today-leave.png"
                  style="margin-top: -1px; margin-right: 2px"
                />
                <span>{{ todayLeave }}</span>
              </div>
              <div
                class="guardian-card__message guardian-card--empty"
                v-if="!messageList[item].length || !messageList[item][0]"
              >
              </div>
              <template v-for="(message, y) in messageList[item]">
                <div
                  class="guardian-card__message mb-8"
                  :key="`message_${y}`"
                  v-if="message"
                  @click="handlerGoToDetail(message)"
                >
                  <div
                    class="card__message mb-12"
                    v-if="message.icon"
                    :style="{
                      'background-image': `url(${require(`../assets/images/guardian/message-${message.icon}.png`)})`
                    }"
                  >
                    <div class="font-26 ff-medium">{{ message.modelName }}</div>
                    <span class="c-171A1D-40 font-22 w-100">{{
                      message.hourMinute
                    }}</span>
                  </div>
                  <div class="font-30 lh-24 mb-8" v-html="message.content">
                  </div>
                  <div
                    class="card__image"
                    v-if="message.bizPicture && message.bizPicture.urls.length"
                    :class="`card__image--${message.bizPicture.style}`"
                  >
                    <template
                      v-if="message.modelId === 1 || message.modelId === 8"
                    >
                      <div
                        v-for="(image, imageIndex) in message.bizPicture.urls"
                        :key="`image${imageIndex}`"
                        class="message-picture"
                        @click.stop="
                          lookImage(message.bizPicture.urls, imageIndex)
                        "
                        :style="{
                          backgroundImage: `url(${image})`
                        }"
                      >
                      </div>
                    </template>
                    <template v-else>
                      <img
                        v-for="(image, imageIndex) in message.bizPicture.urls"
                        :key="`image${imageIndex}`"
                        @click.stop="
                          lookImage(message.bizPicture.urls, imageIndex)
                        "
                        :src="`${image}`"
                      />
                    </template>
                  </div>
                  <!-- 德育考评特殊判定 -->
                  <div
                    class="card__image mt-12 card__image--2 font-34 c-FFFFFF card__image--moral"
                    v-else-if="
                      message.modelId === 20 &&
                      message.bizContent &&
                      message.bizContent.itemName
                    "
                  >
                    {{ message.bizContent.itemName }}
                  </div>
                </div>
                <!-- 第一条消息 -->
                <md-swiper
                  v-if="
                    (!message || message.showSwiper) &&
                    bannerList &&
                    bannerList.length &&
                    !isZjCube &&
                    !isWxPlatform
                  "
                  :key="`swiperBanner${y}`"
                  class="mt-24 mb-24"
                  :show-indicators="bannerList.length > 1"
                  ref="mySwipe"
                  :options="swiperOptions"
                >
                  <md-swiper-item
                    v-for="(item, index) in bannerList"
                    :key="index"
                  >
                    <img
                      @click="handlerGoBanner(item)"
                      :src="item.imgUrl"
                      class="mySwipe__image"
                    />
                  </md-swiper-item>
                </md-swiper>
              </template>
            </div>
            <div
              role="separator"
              v-if="!breakpoint"
              class="van-divider van-divider--dashed van-divider--content-center"
            >
              已经到底了
            </div>
          </div>
        </div>
      </div>
      <div class="fb fb-cross-center fb-main-center mark" v-if="copyConfirm">
        <div class="bd-radio-6 bg-FFFFFF text-center w-280 h-125">
          <div class="bb p-15-0 p-0-32">
            <p class="font-30 lh-22 c-171A1D-56">您有任何意见建议，可邮箱至</p>
            <p class="font-30 lh-22 c-171A1D-56">chanpin@moredian.com</p>
          </div>
          <div class="fb fb-cross-center fb-main-between c-006AFE">
            <span class="font-34 item-flex-1 lh-48" @click="copyConfirm = false"
              >取消</span
            >
            <span
              class="font-34 text-bold item-flex-1 lh-48 bl"
              v-clipboard:copy="copyEmail"
              @click="handleCopySuccess"
              >复制邮箱</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { mcOpenLink } from '@/utils/mcSdkUtils'
import {
  COMMON_RESET_COMMIT,
  WEEK_DAY,
  LEAVE_ROLE,
  PAGE_IN_MODULE
} from '@/utils/constUtils'
import {
  timeFormat,
  dateToTime,
  getCorpId,
  isWxPlatform,
  getItem,
  isHeEducationPlatform
} from '@/utils/comUtils'
import home from '@/mixin/home'
import homeAccess from '@/mixin/homeAccess'
import manageRole from '@/mixin/manageRole'
import { visitorH5Url, ablumAppId } from '@/env'
import face from '@/components/personInfo/face.vue'
import titleIcon from '@/components/personInfo/titleIcon.vue'
const corpId = getCorpId() || ''

const HEADER_MENU_LIST = [
  {
    id: 97,
    name: '开车接送',
    path: '/vehiclemanage/arrive',
    icon: '&#xe6c4;',
    module: '97',
    access: [LEAVE_ROLE.guardian]
  }
]
const END_MENU_LIST = []
const OTHRT_MENU_LIST = [
  {
    id: 46,
    module: '46',
    title: 'visitor',
    name: '预约访客',
    path: `${visitorH5Url}?corpId=${corpId}`,
    icon: '&#xe673;',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.dormAdmin
    ]
  }
]
export default {
  name: 'PageGuardianIndex',
  mixins: [manageRole, home, homeAccess],
  components: { face, titleIcon },
  data() {
    return {
      alertType: (this.$route.query || {}).alertType || '0',
      linkModuleId: (this.$route.query || {}).moduleId || '',
      scrollHeight: 0,
      tableScrollTop: 0,
      parentMenus: [
        {
          moduleId: 97,
          icon: 'vehicle',
          text: '开车接送'
        },
        {
          moduleId: 5,
          icon: 'face',
          text: '信息录入'
        },
        {
          moduleId: 2,
          icon: 'leave',
          text: '请假'
        },
        {
          moduleId: 1,
          icon: 'attendance',
          text: '考勤'
        },
        {
          moduleId: 29,
          icon: 'familycall',
          text: '亲情通话'
        },
        {
          moduleId: 22,
          icon: 'message',
          text: '留言'
        },
        {
          moduleId: 26, // 班级课表和课表关联，所以有26就会有班级课表
          icon: 'educational',
          text: '课表'
        },
        {
          moduleId: 171,
          icon: 'meal',
          text: '学生用餐'
        },
        {
          moduleId: 70,
          icon: 'recipes',
          text: '食谱'
        },
        {
          moduleId: 44,
          icon: 'elective',
          text: '选修课'
        },
        {
          moduleId: 20,
          icon: 'moral',
          text: '德育考评'
        },
        {
          moduleId: 4,
          icon: 'dorm',
          text: '宿舍'
        },

        {
          moduleId: 42,
          icon: 'clearplate',
          text: '光盘行动'
        },
        {
          moduleId: 46,
          icon: 'facedoor',
          text: '来访预约'
        },
        {
          moduleId: 90,
          icon: 'health',
          text: '测温'
        }
      ],
      activeIndex: 0,
      student: {},
      messageList: {},
      dateGather: [],
      formatTime: {},
      notify: [],
      breakpoint: '',
      nowDate: timeFormat(new Date(), 'YYYYMMDD'),
      todayLeave: '',
      leaveStartDate: '',
      leaveEndDate: '',
      callPermission: false, // 亲情通话权限
      miniAppUrl: null, // 第三方付费小程序
      isWxPlatform: isWxPlatform(), // 微信平台-家长端
      isHeEducationPlatform: isHeEducationPlatform(), // 和教育
      showLeaveMessage: false, // 是否开启家长留言模块功能
      hasFace: false
    }
  },
  computed: {
    cpIsHaveAblum() {
      return (getItem('graybus') || '').includes(200)
    },
    cpHeaderMenus() {
      const { moduleIdList } = this.$store.getters.skuInfo
      return HEADER_MENU_LIST.filter(item => {
        return moduleIdList.includes(item.module)
      })
    },
    cpEndMenus() {
      const { moduleIdList } = this.$store.getters.skuInfo
      return END_MENU_LIST.filter(item => {
        return moduleIdList.includes(item.module)
      })
    },
    iconList() {
      let TARGET_LIST = []
      let allMenus = [
        ...this.cpHeaderMenus,
        {
          module: 5,
          icon: 'face',
          text: '信息录入'
        },
        ...this.appList,
        ...this.appEducationalMenus,
        ...this.appLeaveSchoolMenus,
        ...this.appOtherList,
        ...this.appDeviceList,
        ...this.appBasicList,
        ...this.appServeList,
        ...this.appEvaluationList,
        ...this.cpEndMenus
        // ...(this.isZjCube || this.isWxPlatform ? [] : OTHRT_MENU_LIST)
      ]
      const { moduleIdList } = this.$store.getters.skuInfo
      if (
        moduleIdList.includes('46') &&
        !(this.isZjCube || this.isWxPlatform)
      ) {
        allMenus = allMenus.concat(OTHRT_MENU_LIST)
      }
      // 微信家长端先隐藏访客
      if (this.isWxPlatform || this.isHeEducationPlatform) {
        allMenus = allMenus.filter(item => item.module !== '46')
      }
      this.parentMenus.forEach(item => {
        const index = allMenus.findIndex(
          menu => +menu.module === +item.moduleId
        )
        // 补充逻辑：亲情通话设备都过期，不显示给孩子留言
        // (item.moduleId !== 22 || this.$store.getters.unExpireNum > 0)
        if (index > -1 && this.mCheckMenus(item)) {
          TARGET_LIST.push({
            ...allMenus[index],
            ...item
          })
        }
      })
      return TARGET_LIST
    },
    computedShowCustomerService() {
      return (
        (this.isAdmin || this.isTeacher || this.isHeadmaster) &&
        !this.isWxPlatform
      )
    },
    computedStudentCampusId() {
      return this.student.campusId
    },
    // 待办及通知列表展示
    cpNotifyList() {
      return this.mdFilterNoticeList()
    }
  },
  async activated() {
    // 魔方机构 家长不展示来访预约
    if (this.isZjCube) {
      const index = this.parentMenus.findIndex(item => item.id === 46)
      index > -1 && this.parentMenus(index, 1)
    }
    // this.setRightMenu()
    if (this.student.campusId ? true : await this.initStudent()) {
      this.getMessageFlow()
      this.getTodayLeaveStatus()
      this.getBannerList()
      this.getUpcomingList()
      // 重置store
      COMMON_RESET_COMMIT.forEach(item => {
        this.$store.commit(item.key, item.value)
      })
      // 激活后重新设置滚动条
      this.activateScroll()
    }
    this.getStudentFaceStatus()
  },
  /* eslint-disable */
  watch: {
    // 监听学生信息
    student: {
      deep: true,
      async handler(v) {
        // 判断是否有使用权限
        await this.judgeCanAccessGuardian(v.tpId)
        this.getStudentFaceStatus()
      }
    },
    // 监听学生campusId变化，重置 currentCapmus
    computedStudentCampusId: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.$store.commit('studentNumber', this.student.memberId)
          this.$store.dispatch('guardianInitCampus')
          // 更新学年学期
          this.$store
            .dispatch('handlerCheckSemester', {
              campusId: val
            })
            .finally(() => {
              if (this.$store.getters.semesterSetting.showTermDialog) {
                this.$Dialog({
                  type: 'alert',
                  title: '提示',
                  content: '学期时间暂未设置，请联系管理员。',
                  confirmBtn: '我知道了'
                }).show()
              }
            })
        }
      }
    }
  },
  beforeDestroy() {
    this.$el.removeEventListener(
      'scroll',
      () => {
        this.tableScrollTop = 0
      },
      false
    )
  },
  beforeRouteLeave(to, from, next) {
    if (to && (to.path === '/wcode' || to.path === '/wechat/bind')) {
      WeixinJSBridge.call('closeWindow')
      next(false)
    } else {
      next()
    }
  },
  async mounted() {
    // this.setRightMenu()
    const initStudent = await this.initStudent()
    if (initStudent) {
      await this.getCallPermission() //获取学生亲情通话权限
      this.$nextTick(() => {
        this.scrollHeight = this.$refs.pageSubstituteIndex.clientHeight
        // 监听滚动条的位置
        this.$el.addEventListener(
          'scroll',
          () => {
            this.tableScrollTop = this.$el.scrollTop
          },
          false
        )
      })
    }
    document.addEventListener('visibilitychange', this.documentVisible)
    this.$nextTick(() => {
      if (this.alertType === '1') {
        const _module = this.iconList.filter(
          item => item.module === this.linkModuleId
        )
        _module.length && this.goPage(_module[0])
      }
    })
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.documentVisible)
  },
  methods: {
    // 跳转电子相册
    goAblum() {
      const queryStr = encodeURIComponent(
        `pages/index/index?memberId=${this.student.memberId}&orgId=${this.orgId}&studentDingId=${this.student.tpId}&corpId=${corpId}`
      )

      mcOpenLink({
        url: `dingtalk://dingtalkclient/action/open_mini_app?miniAppId=${ablumAppId}&page=${queryStr}`
      })
    },
    documentVisible() {
      if (!document.hidden) {
        this.getStudentFaceStatus()
      }
    },
    // 查询学生录脸状态
    getStudentFaceStatus() {
      if (!(this.student || {}).tpId) {
        return
      }
      const params = {
        ...this.commonParams2,
        studentDingIds: this.student.tpId
      }
      API.getStudentFamilyFaceCount(params)
        .then(data => {
          const hasFace = data.find(
            ele => ele.tpId === this.student.tpId
          ).hasFace
          this.hasFace = hasFace
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 校验菜单
    mCheckMenus(item) {
      let flag = true

      switch (item.moduleId) {
        // 信息录入
        case 5:
          flag = this.mCheckInfoMenu()
          break
        // 家长留言（星然家长留言隐藏，其他开放，根据服务端showLeaveMessage字段判断）
        case 22:
        case 29:
          flag = this.showLeaveMessage
          break

        default:
          break
      }

      return flag
    },
    // 校验信息录入菜单(微信1期不展示信息录入模块)
    mCheckInfoMenu() {
      return (
        this.moduleIdList.includes('5') &&
        !this.$store.getters.mixCloudOrg &&
        !this.isWxPlatform
      )
    },
    // 过滤待办 & 通知列表
    mdFilterNoticeList() {
      let list =
        this.notify.filter(
          item =>
            item.modelId !== 22 ||
            (item.modelId === 22 && this.showLeaveMessage)
        ) || []

      return list
    },
    async lookImage(list, index) {
      if (!(await this.judgeCanAccessGuardian())) {
        return false
      }
      this.$ImagePreview({
        $props: {
          images: list,
          content: '',
          start: index
        }
      }).show()
    },
    nameFormat(value, len) {
      if (!value) {
        return
      }
      if (value.length <= len) {
        return value
      }
      if (len === 9) {
        return value.slice(0, 7) + '...'
      }
      return value.slice(0, 3) + '...' + value.slice(value.length - 1)
    },

    activateScroll() {
      this.$nextTick(() => {
        this.$el.scrollTop = this.tableScrollTop
      })
    },
    // 分页加载数据
    async handlerScroll(e) {
      if (!this.breakpoint) {
        return
      }
      let _el = e.currentTarget
      if (
        this.breakpoint &&
        _el.scrollTop + _el.clientHeight >= _el.scrollHeight - 20
      ) {
        if (!(await this.judgeCanAccessGuardian())) {
          return false
        }
        this.getMessageFlow(false)
      }
    },
    // 动态设置menu
    setRightMenu() {
      if (!this.isZjCube) {
        const _buttonName = ['帮助中心'],
          _routes = [
            `https://moredian.yuque.com/staff-yb2nlp/gfhgbl/uml6zw?singleDoc#`
          ],
          _linkType = [1]
        setTimeout(() => {
          this.handlerCommonSetRightMenu(
            _buttonName,
            _routes,
            [],
            _linkType,
            this
          )
        }, this.rightTime)
      }
    },
    async handlerClickNotice(notice) {
      if (!(await this.judgeCanAccessGuardian())) {
        return false
      }
      const target = this.iconList.filter(v => v.moduleId === notice.modelId)
      this.$router.push({
        path:
          typeof target[0].path === 'string'
            ? target[0].path
            : target[0].path[1],
        query: notice
      })
    },
    // H5通知待办
    getUpcomingList() {
      return new Promise((resolve, reject) => {
        API.getUpcomingList({
          campusId: this.student.campusId,
          operUserRoleTypes: this.currentRole,
          studentDingId: this.student.tpId
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return
            }
            this.notify = res
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      })
    },
    // H5消息中心
    getMessageFlow(reset = true) {
      if (reset) {
        this.breakpoint = ''
      }
      let params = {
        campusId: this.student.campusId,
        classDingId: this.student.dingClassesId,
        operUserRoleTypes: this.currentRole,
        studentDingId: this.student.tpId,
        limit: 10,
        breakpoint: this.breakpoint
      }
      if (!this.breakpoint) {
        delete params.breakpoint
      }
      this.breakpoint = ''
      API.getMessageFlow(params)
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return
          }
          if (reset) {
            this.messageList = {}
            this.formatTime = {}
            this.dateGather = []
          }
          this.$nextTick(() => {
            this.breakpoint = res.messageVoList.length ? res.breakpoint : ''
            if (!this.breakpoint) {
              // 无数据
              if (!this.dateGather.length) {
                this.dateGather.push(timeFormat(new Date(), 'YYYYMMDD'))
                this.messageList[timeFormat(new Date(), 'YYYYMMDD')] = [null]
                this.formatTime[timeFormat(new Date(), 'YYYYMMDD')] =
                  '今天 ' + WEEK_DAY[new Date().getDay()]
              }
              return
            }
            let parentMenusMap = {}
            // 指定icon
            this.parentMenus.map(v => {
              parentMenusMap[v.moduleId] = v.icon
            })
            res.messageVoList.map((v, index) => {
              // 解析json串
              v.bizContent = JSON.parse(v.bizContent)
              // 31 30 8
              v.icon = parentMenusMap[v.modelId] || 'attendance'
              // 转化date
              let dateTime = new Date(+v.messageTime)
              let dimDay = timeFormat(dateTime, 'YYYYMMDD')
              v.hourMinute = timeFormat(dateTime, 'hh:mm')
              v.content = v.content.replace(/\n/g, '<br/>')

              if (!this.messageList[dimDay]) {
                this.messageList[dimDay] = []
              }
              this.messageList[dimDay].push(v)

              this.formatTime[dimDay] =
                (dimDay === timeFormat(new Date(), 'YYYYMMDD')
                  ? '今天'
                  : timeFormat(dateTime, 'MM.DD')) +
                ' ' +
                WEEK_DAY[dateTime.getDay()]
            })
            // 今日的必须存在
            if (!this.messageList[timeFormat(new Date(), 'YYYYMMDD')]) {
              this.dateGather.push(timeFormat(new Date(), 'YYYYMMDD'))
              this.messageList[timeFormat(new Date(), 'YYYYMMDD')] = [null]
              this.formatTime[timeFormat(new Date(), 'YYYYMMDD')] =
                '今天 ' + WEEK_DAY[new Date().getDay()]
            }
            this.dateGather = Object.keys(this.messageList).sort((n1, n2) => {
              return n2 - n1
            })
            for (let index = 0; index < this.dateGather.length; index++) {
              const item = this.dateGather[index]
              for (let y = 0; y < this.messageList[item].length; y++) {
                const message = this.messageList[item][y]
                if (!message) {
                  return
                }
                if (
                  (index === 0 &&
                    y === 0 &&
                    message.bizPicture &&
                    message.bizPicture.urls &&
                    message.bizPicture.urls.length) ||
                  (index === 0 && y === 1) ||
                  (index === 1 && y === 0)
                ) {
                  message.showSwiper = true
                  return
                }
              }
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 查询今日请假状态
    getTodayLeaveStatus() {
      this.todayLeave = ''
      this.leaveStartDate = ''
      this.leaveEndDate = ''
      return new Promise((resolve, reject) => {
        API.getTodayLeaveStatus({
          campusId: this.student.campusId,
          studentId: this.student.tpId,
          operUserRoleTypes: this.currentRole
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return
            }
            if (!res.isLeave) {
              return
            }
            let startTimeDate = new Date(+res.startTime)
            let endTimeDate = new Date(+res.endTime)
            let startTime = timeFormat(startTimeDate, 'MM.DD')
            let endTime = timeFormat(endTimeDate, 'MM.DD')
            this.leaveStartDate = timeFormat(startTimeDate, 'YYYYMMDD')
            this.leaveEndDate = timeFormat(endTimeDate, 'YYYYMMDD')
            let hourMinute1, hourMinute2
            // 按小时展示
            if (res.leaveDurationUnit === 1) {
              hourMinute1 = timeFormat(startTimeDate, 'MM.DD hh:mm')
              hourMinute2 = timeFormat(endTimeDate, 'MM.DD hh:mm')
              this.todayLeave = `请假中（${hourMinute1} ~ ${hourMinute2}）`
            } else {
              hourMinute1 =
                timeFormat(startTimeDate, 'hhmm') < 1200 ? '上午' : '下午'
              hourMinute2 =
                timeFormat(endTimeDate, 'hhmm') < 1200 ? '上午' : '下午'
              this.todayLeave = `请假中（${startTime}${hourMinute1} ~ ${endTime}${hourMinute2}）`
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      })
    },
    initStudent() {
      return new Promise((resolve, reject) => {
        let storeMemberId = this.$store.getters.studentNumber
        const childList = this.$store.getters.studentList
        if (!childList.length) {
          this.student = {}
          window.location.hash = '#/'
          resolve(false)
        } else {
          let index = 0
          if (storeMemberId) {
            index = childList.findIndex(
              v => v.memberId + '' === storeMemberId + ''
            )
            index = index === -1 ? 0 : index
          }
          this.student = childList[index]
          this.activeIndex = index
          this.$store.commit('studentNumber', this.student.memberId)
          resolve(true)
        }
      })
    },
    switchChild() {
      if (this.$store.getters.studentList.length === 1) {
        return
      }
      let _students = []
      ;(this.$store.getters.studentList || []).map(item => {
        _students.push({
          ...item,
          id: item.memberId
        })
      })
      let _that = this
      this.$ActionSheet({
        title: '选择学生',
        cancelText: '关闭',
        actions: _students,
        onChoose(item, index) {
          _that.activeIndex = index
          _that.student = item
          _that.$store.commit('studentNumber', item.memberId)
          _that.messageList = {}
          _that.formatTime = {}
          _that.dateGather = []
          _that.breakpoint = ''
          _that.getUpcomingList()
          _that.getMessageFlow()
          _that.getTodayLeaveStatus()
          _that.getCallPermission()
        },
        active: this.activeIndex
      }).show()
    },
    async goPage(row) {
      // 给孩子留言模块，如果亲情通话设备全部到期，提示不可用
      if (
        [22, 29].includes(row.moduleId) &&
        this.$store.getters.unExpireNum === 0
      ) {
        this.$Dialog({
          title: '无法使用',
          confirmBtn: {
            color: '#006afe',
            text: '我知道了'
          },
          content: `套餐到期，请联系相关老师开通。`,
          onConfirm() {
            return false
          }
        }).show()
        return false
      }
      if (!(await this.judgeCanAccessGuardian())) {
        return false
      }
      const leaveMessageFlag = await this.leaveMessage(row)
      //是否开通留言
      if (leaveMessageFlag) return
      // 每次切换模块，把导航清空
      this.$store.commit('setRouteForTabbar', [])
      // 录脸
      if (row.moduleId === 5) {
        // 公众号信息录入
        if (this.isWxPlatform) {
          this.mixinRouter('/faceInput/guardian')
        } else {
          // 家长进入
          this.$router.push({
            name: 'PageEntryInformationGuardian'
          })
        }
      } else if (
        [
          ...this.appOtherList,
          ...(this.isZjCube || this.isWxPlatform ? [] : OTHRT_MENU_LIST)
        ].findIndex(v => +v.module === +row.moduleId) !== -1
      ) {
        // 走外链
        this.handlerLinkOthers(row)
      } else {
        // 走自定义
        this.handlerClickItem(row)
      }
    },
    // 内页详情
    async handlerGoToDetail({ modelId, messageTime, bizContent, campusId }) {
      if (!(await this.judgeCanAccessGuardian())) {
        return false
      }
      let path = '',
        query = {},
        dimDay = timeFormat(new Date(+messageTime), 'YYYYMMDD')
      switch (modelId) {
        case 1:
          path = '/attendance/index'
          query.guardianDate = messageTime
          break
        // 请假
        case 2:
          const _grayPath = (getItem('graybus') || '').indexOf(
            PAGE_IN_MODULE.leave
          )
            ? bizContent.approveStatus !== 1
            : bizContent.approveStatus === 7 ||
              (bizContent.approveStatus === 5 && bizContent.cancelType === 2)
          if (_grayPath || this.isWxPlatform) {
            path = '/leave/detail'
            query.leaveId = bizContent.leaveId
          } else {
            return mcOpenLink({
              url: bizContent.dingUrl
            })
          }
          break
        // 德育考评
        case 20:
          path = '/classcard/moralstudent'
          query = {
            type: 1,
            dimDay,
            campusId
          }
          break
        //  课表
        case 26:
          path = '/schedule/student'
          query = {
            tomorrow: new Date(dateToTime(bizContent.dimDay, '.')).getTime()
          }
          break
        //  光盘行动
        case 42:
          path = '/classcard/clearplate/personal'
          query = {
            dimDay
          }
          break
        //  食谱
        case 70:
          path = '/recipes/adminDaily'
          query = {
            dimDay,
            // 当前周的开始结束日期、当前周ID，当前学年
            startDay: bizContent.teachWeekStartDimDay,
            endDay: bizContent.teachWeekEndDimDay,
            weekId: bizContent.teachWeekId,
            schoolYear: bizContent.schoolYear || ''
          }
          break
        default:
          break
      }
      // 每次切换模块，把导航清空
      this.$store.commit('setRouteForTabbar', [])
      this.$router.push({
        path,
        query
      })
    },

    handlerClickItem(app) {
      const _path = app.multiple ? app.path[this.currentRole] : app.path
      if (app.linkType === 2) {
        const { moduleIdList } = this.$store.getters.skuInfo
        mcOpenLink({
          url: `${app.path}&currentRole=${this.currentRole}&campusId=${
            this.campusId
          }&memberId=${this.student.memberId}${
            // 套餐包含94 跳转到重庆防疫
            app.module === '90' && moduleIdList.some(item => +item === 94)
              ? '&modu=94'
              : ''
          }${
            this.isWxPlatform
              ? `&platformSource=${getItem('platformSource')}`
              : ''
          }`
        })
      } else {
        switch (app.moduleId) {
          case 171:
            app.query = { studentDingId: this.student.tpId }
            break
        }
        this.$router.push({ path: _path, query: app.query || {} })
      }
      // 每次切换模块，把导航清空
      this.$store.commit('setRouteForTabbar', [])
    },
    // 获取亲情通话权限
    async getCallPermission() {
      try {
        const res = await API.getCallPermission({
          studentDingId: this.student.tpId,
          campusId: this.student.campusId,
          moduleId: 29
        })
        this.callPermission = res.hasPermission
        this.miniAppUrl = res.url
        this.showLeaveMessage = res.showLeaveMessage
      } catch (error) {
        console.log(error)
      }
    },
    // 判断是否为留言功能，是否有权限，false为未开通
    async leaveMessage(row) {
      if ([22, 29].includes(row.moduleId) && !this.callPermission) {
        await this.getCallPermission()
        if (!this.callPermission) {
          this.$Dialog({
            type: 'confirm',
            title: '无法使用',
            content: '暂未开通学生留言及亲情通话功能，请开通后使用',
            confirmBtn: {
              text: '去开通',
              color: '#006AFE'
            },
            cancelBtn: {
              text: '关闭',
              color: '#006AFE'
            },
            $events: {
              confirm: () => {
                if (this.miniAppUrl) {
                  // 跳转到钉钉小程序
                  mcOpenLink({
                    // 动态获取
                    url: this.miniAppUrl
                  })
                } else {
                  this.$router.push({
                    path: '/familycall/paymenus',
                    query: {}
                  })
                }
              },
              cancel: () => {}
            }
          }).show()
          return true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.van-divider {
  display: flex;
  align-items: center;
  margin: 16px 0;
  color: #969799;
  font-size: 14px;
  line-height: 24px;
  border-color: #ebedf0;
  border-style: solid;
  border-width: 0;
}
.van-divider--content-center::before {
  margin-right: 16px;
}

.van-divider--hairline::before,
.van-divider--hairline::after {
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.van-divider--content-center::after {
  margin-left: 16px;
  content: '';
}
.van-divider--hairline::before,
.van-divider--hairline::after {
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.van-divider::before {
  content: '';
}
.van-divider::before,
.van-divider::after {
  display: block;
  flex: 1;
  box-sizing: border-box;
  height: 1px;
  border-color: inherit;
  border-style: inherit;
  border-width: 1px 0 0;
}
.guardian {
  height: 724px;
  background: linear-gradient(180deg, #eaecff, #f2f2f6 65%);
  .guardian-wrapper {
    padding-left: 16px;
    padding-right: 16px;
    height: 100%;
    background: url(~@/assets/images/guardian/bg-clouds.png) no-repeat center
      75px;
    background-size: contain;
  }
  .guardian-header {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .guardian-header__avatar {
      width: 54px;
      height: 54px;
      border: 1px solid #ffffff;
      border-radius: 100px;
      margin-right: 6px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
    img {
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
  }
  .guardian-module-wrapper {
    background: #ffffff;
    height: 84px;
    padding: 0 15px;
    border-radius: 12px;
    box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.08);
    .guardian-module {
      height: 100%;
      display: flex;
      text-align: center;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
      overflow-x: auto;
      overflow-y: hidden;
      & > li {
        flex-shrink: 0;
        min-width: 45px;
        margin-right: 14px;
        img {
          width: 32px;
        }
        p {
          line-height: normal;
        }
      }
    }
  }

  .guardian-notice {
    background: #ffffff;
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      background: #e8ebff;
      border: 1px solid #4250c3;
      border-radius: 4px;
      color: #4250c3;
      padding: 1px 4px;
      line-height: normal;
      display: inline-block;
      vertical-align: middle;
    }
    i {
      color: #bfbfbf;
    }
  }
  .guardian-card {
    .guardian-card__date {
      width: 80px;
      height: 29px;
      background: #ffffff;
      border-radius: 32px 32px 32px 0px;
      margin-bottom: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .guardian-card--empty {
      height: 250px;
      background-image: url('~@/assets/images/guardian/guardian-emtpy.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 200px 200px;
    }
    .guardian-card__message {
      background-color: #ffffff;
      border-radius: 16px;
      padding: 16px;
      .card__message {
        padding-left: 40px;
        height: 32px;
        text-align: left;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: 32px 32px;
      }
      .card__image {
        img {
          border-radius: 8px;
        }
      }
      .card__image--moral {
        background: rgba(0, 176, 66, 0.48);
      }
      .card__image--2 {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        img {
          border-radius: 50%;
        }
      }
      .card__image--3 {
        overflow: hidden;
        img {
          width: 152px;
          height: 94px;
          float: left;
          margin-right: 6px;
          margin-bottom: 6px;
          &:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.guardian__leave {
  padding: 12px 0;
  background: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  margin-bottom: 8px;
  img {
    width: 24px;
    height: 24px;
  }
}
.message-picture {
  height: 100px;
  width: 100px;
  border-radius: 8px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.mySwipe__image {
  height: 84px;
  border-radius: 12px;
}
:deep(.md-swiper) {
  font-size: 0;
}
:deep(.md-swiper .md-swiper__indicators--icon) {
  color: rgba(255, 255, 255, 0.4);
}
:deep(.md-swiper .md-swiper__indicators--icon.is-active) {
  color: rgba(255, 255, 255, 1);
}
:deep(.md-swiper .md-swiper__indicators) {
  bottom: 5px;
}
.mark {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
}

.cs-tip {
  right: 16px;
  bottom: -28px;
  z-index: 2099;
  &.is-top {
    :deep(.md-tip__indicator) {
      left: 100%;
      transform: translateX(-36px);
      margin-top: -5px;
    }
    :deep(.md-tip__content) {
      height: 20px;
      line-height: 20px;
    }
  }
}
.switch-icon {
  margin-top: 4px;
}
</style>
